"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Datepicker = exports.months = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const getMonth_1 = __importDefault(require("date-fns/getMonth"));
const getYear_1 = __importDefault(require("date-fns/getYear"));
const ru_1 = __importDefault(require("date-fns/locale/ru"));
const react_1 = __importStar(require("react"));
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const datepicker_control_1 = require("./datepicker-control");
const datepicker_styles_1 = require("./datepicker.styles");
const datepicker_types_1 = require("./datepicker.types");
const ArrowLeft = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/arrow-left'))));
const ArrowRight = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/arrow-right'))));
exports.months = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
];
const defaultDateFormat = 'dd.MM.yyyy';
exports.Datepicker = (0, react_1.memo)((0, react_1.forwardRef)((props, ref) => {
    const theme = (0, theme_1.useTheme)();
    const datePickerRef = (0, react_1.useRef)(null);
    const [calendarIsOpen, setCalendarIsOpen] = (0, react_1.useState)(false);
    const [isValueSelected, setIsValueSelected] = (0, react_1.useState)(false);
    const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
    const { showYearDropdown, showMonthDropdown, error, isSelectsRange, startDate, endDate, sizeType = datepicker_types_1.SizeType.LARGE, } = props;
    const years = range(1900, (0, getYear_1.default)(new Date()) + 1, 1);
    const handleOnSelect = () => {
        var _a;
        if (!isSelectsRange || (startDate && !endDate)) {
            (_a = datePickerRef === null || datePickerRef === void 0 ? void 0 : datePickerRef.current) === null || _a === void 0 ? void 0 : _a.setOpen(false);
        }
    };
    const handleOnFocus = (0, react_1.useCallback)((event) => {
        setIsValueSelected(true);
        setCalendarIsOpen(true);
        if (props === null || props === void 0 ? void 0 : props.onFocus)
            props.onFocus(event);
    }, [props === null || props === void 0 ? void 0 : props.onFocus]);
    const handleOnBlur = (0, react_1.useCallback)((event) => {
        setIsValueSelected(false);
        if (props === null || props === void 0 ? void 0 : props.onBlur)
            props.onBlur(event);
    }, [props === null || props === void 0 ? void 0 : props.onBlur]);
    const handleOnCalendarClose = (0, react_1.useCallback)(() => {
        setIsValueSelected(false);
        setCalendarIsOpen(false);
        if (props === null || props === void 0 ? void 0 : props.onCalendarClose)
            props.onCalendarClose();
    }, [props === null || props === void 0 ? void 0 : props.onCalendarClose]);
    (0, react_1.useImperativeHandle)(ref, () => datePickerRef.current);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_datepicker_1.default, Object.assign({ disabledKeyboardNavigation: true, renderCustomHeader: ({ date, decreaseMonth, increaseMonth, changeYear, changeMonth, prevMonthButtonDisabled, nextMonthButtonDisabled, }) => (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(datepicker_styles_1.StyledDatepickerSelectGroup, null,
                    react_1.default.createElement(datepicker_styles_1.StyledDatepickerButton, { onClick: decreaseMonth, disabled: prevMonthButtonDisabled },
                        react_1.default.createElement(react_1.Suspense, { fallback: null },
                            react_1.default.createElement(ArrowLeft, { color: theme.colors.icon.primary }))),
                    react_1.default.createElement(datepicker_styles_1.StyledDatepickerMonth, null, `${exports.months[(0, getMonth_1.default)(date)]} ${(0, getYear_1.default)(date)}`),
                    react_1.default.createElement(datepicker_styles_1.StyledDatepickerButton, { onClick: increaseMonth, disabled: nextMonthButtonDisabled },
                        react_1.default.createElement(react_1.Suspense, { fallback: null },
                            react_1.default.createElement(ArrowRight, { color: theme.colors.icon.primary })))),
                (showMonthDropdown || showYearDropdown) && (react_1.default.createElement(datepicker_styles_1.StyledDatepickerSelectGroup, null,
                    react_1.default.createElement(datepicker_styles_1.StyledDatepickerSecondGroup, null,
                        showYearDropdown ? (react_1.default.createElement(datepicker_styles_1.StyledSelect, { value: (0, getYear_1.default)(date), onChange: ({ target: { value } }) => changeYear(Number(value)) }, years.map((option) => (react_1.default.createElement("option", { key: option, value: option }, option))))) : null,
                        showMonthDropdown ? (react_1.default.createElement(datepicker_styles_1.StyledSelect, { value: exports.months[(0, getMonth_1.default)(date)], onChange: ({ target: { value } }) => changeMonth(exports.months.indexOf(value)) }, exports.months.map((option) => (react_1.default.createElement("option", { key: option, value: option }, option))))) : null))))), ref: datePickerRef, open: calendarIsOpen, locale: ru_1.default, dateFormat: defaultDateFormat, showPopperArrow: false, showTimeSelect: true, onSelect: handleOnSelect, selectsRange: isSelectsRange, customInput: react_1.default.createElement(datepicker_control_1.DatepickerControl, Object.assign({ error: error, isValueSelected: isValueSelected, datePickerRef: datePickerRef, sizeType: sizeType }, props)), calendarContainer: datepicker_styles_1.StyledDatepickerContainer }, props, { onFocus: handleOnFocus, onBlur: handleOnBlur, onCalendarClose: handleOnCalendarClose })),
        react_1.default.createElement(datepicker_styles_1.DatePickerWrapperStyles, null)));
}));
